import * as React from 'react';
import { Layout, Col, Row } from 'antd';
import AppMenu from '../../AppMenu';
import AppRoute from '../../../../Core/models/AppRoute';
import Logo from '../../../Styled/Logo';
import UserBar from '../../UserBar';
import AuthBar from 'components/Layout/AuthBar';
import { CenterAlignRow } from 'components/Styled/Layout.Styled';
import AuthContext from 'Context/AuthContext';

const { Header } = Layout;

export interface Props {
  children?: React.ReactNode;
  menu: AppRoute[];
}

export interface State { isLoggedIn: boolean; }

export default class TopBar extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = { isLoggedIn: false };
  }

  static contextType = AuthContext;
  context!: React.ContextType<typeof AuthContext>;

  componentDidMount() {
    if (this.context.data) {
      this.setState({ isLoggedIn: true });
    }
  }

  render() {
    return (
      <Header>
        <CenterAlignRow type="flex" align="middle">
          <Col
            xs={{ span: 12, order: 2, offset: 5 }}
            sm={{ span: 12, order: 2, offset: 5 }}
            md={{ span: 12, order: 2, offset: 5 }}
            lg={{ span: 3, order: 1, offset: 0 }}
            xl={{ span: 3, order: 1, offset: 0 }}>
            <Logo disableLinking={false} />
          </Col>
          <Col
            xs={{ span: 1, order: 1 }}
            sm={{ span: 1, order: 1 }}
            md={{ span: 1, order: 1 }}
            lg={{ span: (this.state.isLoggedIn ? 15 : 18), order: 2 }}
            xl={{ span: (this.state.isLoggedIn ? 15 : 18), order: 2 }}>

            <Row justify="center">
              <Col>
                <AppMenu mode="horizontal" menu={this.props.menu} />
              </Col>
            </Row>
          </Col>
          <Col
            xs={{ span: 6, order: 3 }}
            sm={{ span: 6, order: 3 }}
            md={{ span: 6, order: 3 }}
            lg={{ span: (this.state.isLoggedIn ? 6 : 3), order: 3 }}
            xl={{ span: (this.state.isLoggedIn ? 6 : 3), order: 3 }}>
            <AuthBar />
          </Col>
        </CenterAlignRow>
      </Header>
    );
  }
}
